import { motion } from "framer-motion";
import { Phone, ChevronDown } from "lucide-react";
import { IMAGES, CONTACT } from "../data/content";

export const Hero = ({ onEnquire }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[640px] w-full overflow-hidden flex flex-col justify-center"
    >
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 8, ease: "easeOut" }}
        className="absolute inset-0"
      >
        <img
          src={IMAGES.heroBackground}
          alt="Misty Himalayan pine forest at Nine Furlongs"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/40" />

      <div className="relative max-w-7xl mx-auto w-full px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="uppercase text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] text-[#C4A575] font-semibold mb-4 sm:mb-6"
        >
          A Deep Forest Heritage Estate · Binsar, Almora
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="font-serif text-[#F6F5F0] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-3xl text-balance"
        >
          To lose yourself there,
          <br />
          is to find yourself here.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="text-[#EFECE4]/90 text-base md:text-lg max-w-xl mt-7 leading-relaxed"
        >
          A luxury forest retreat above the clouds — heritage bungalows, slow
          mountain cuisine and 300° Himalayan views, hidden deep in the Binsar
          valley.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="flex flex-col sm:flex-row gap-4 mt-10"
        >
          <button
            onClick={onEnquire}
            data-testid="hero-enquire-button"
            className="bg-[#C4A575] text-primary px-9 py-4 uppercase text-sm tracking-[0.18em] font-medium hover:bg-[#b3935f] transition-colors"
          >
            Check Availability
          </button>
          <a
            href={CONTACT.phoneHref}
            data-testid="hero-call-button"
            className="flex items-center justify-center gap-2 border border-[#F6F5F0]/60 text-[#F6F5F0] px-9 py-4 uppercase text-sm tracking-[0.18em] hover:bg-[#F6F5F0] hover:text-primary transition-colors"
          >
            <Phone size={16} /> Call to Book
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#F6F5F0]/70"
      >
        <ChevronDown className="animate-bounce" size={26} />
      </motion.div>
    </section>
  );
};
